import {
	getLineStatusHistorySteps,
	getOrderStatusHistorySteps,
} from "../constants/orderStatusHistory";

export const generateStatusHistorySteps = ({
	order,
	lineId = null,
	mode = "order",
}) => {
	if (!order) {return [];}
	const steps =
		mode === "line"
			? getLineStatusHistorySteps(order)
			: getOrderStatusHistorySteps(order);

	let current_index = 0;
	const status_history =
		mode === "line"
			? order.status_history.filter(
					({ content_type, object_id }) =>
						content_type === "line" && object_id === lineId
			  )
			: order.status_history;

	const histories = steps.map((status, i) => {
		let obj = { ...status };

		const matches = status_history.filter(({ new_status }) => {
			const statusText =
				typeof new_status === "object"
					? new_status.name?.toLowerCase()
					: new_status?.toLowerCase();

			return statusText === obj.filter;
		});

		if (matches.length) {
			const lastMatch = matches[matches.length - 1];
			obj = { ...obj, ...lastMatch };
			obj.completed = true;
			current_index = current_index = obj.lines_exist ? current_index : i;
		}

		if (mode === "order" && obj.lines_exist) {
			obj.lines = status_history.filter(
				({ new_status, content_type }) =>
					content_type === "line" &&
					(typeof new_status === "object"
						? new_status.name?.toLowerCase()
						: new_status?.toLowerCase()) === obj.filter
			);
			obj.order_lines = order.lines;
			const completed = obj.lines.length >= order.lines.length;
			obj.completed = completed;

			if (completed) {current_index = i;}
		}

		return obj;
	});

	return {
		histories,
		current_index,
	};
};
